export default class SuccessDialogCtrl {

  constructor ($scope, WorkPlanModalSrv, $mdDialog, $state, GlobalConfig) {
    let ctrlModalVM = this
    const texts = GlobalConfig.appTexts
    const shared                 = WorkPlanModalSrv.getVariableSuccessDialog()
    ctrlModalVM.nameModal        = shared.nameModal
    ctrlModalVM.itemName         = shared.itemName
    ctrlModalVM.createOrEdit     = shared.createOrEdit
    ctrlModalVM.textCreateOrEdit = shared.textCreateOrEdit
    ctrlModalVM.modalType        = shared.modalType

    ctrlModalVM.close = close

    function close(){
    //compare for Investigation submodule
      if(isProduct(ctrlModalVM.modalType)){
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.products')
        }
      } else if (isProject(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.projects')
        }
      } else if (isCollaborationSpace(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.collaborationSpaces')
        }
      } else if (isProjectFormulation(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.investigation')
        }
      } else if (isResultsTransfer(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.resultsTransfer')
        }
      } else if (isTrainingResearch(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionInvestigation'){
          $state.reload()
        }else{
          $state.go('workplan.trainingResearch')
        }
    //compare for Extension submodule
      } else if (isProjectFormulationExt(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionExtension'){
          $state.reload()
        }else{
          $state.go('workplan.projectProposalFormulation')
        }
      } else if (isCounselingConsultancy(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionExtension'){
          $state.reload()
        }else{
          $state.go('workplan.counselingAndConsultancy')
        }
      } else if (isShortCourses(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionExtension'){
          $state.reload()
        }else{
          $state.go('workplan.shortCourses')
        }
      } else if (isExtensionProject(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionExtension'){
          $state.reload()
        }else{
          $state.go('workplan.extensionProjects')
        }
      } else if (isVisibility(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionExtension'){
          $state.reload()
        }else{
          $state.go('workplan.visibilityAndComunication')
        }
    //compare for Consolidation CP submodule
      } else if (isDoctoralFormation(ctrlModalVM.modalType)) {
        if($state.current.name == 'workplan.executionConsolidation'){
          $state.reload()
        }else{
          $state.go('workplan.doctoralFormation')
        }
      } else if (isLearningCommunitie(ctrlModalVM.modalType)){
        if($state.current.name == 'workplan.executionConsolidation'){
          $state.reload()
        }else{
          $state.go('workplan.learningAndPracticeCommunities')
        }
      } else if (isTeachingDev(ctrlModalVM.modalType)){
        if($state.current.name == 'workplan.executionConsolidation'){
          $state.reload()
        }else{
          $state.go('workplan.teachingDevelopment')
        }
    //compare for Academic Management submodule
      } else if (isComiteeParticipation(ctrlModalVM.modalType)){
        if($state.current.name === 'workplan.createParticipation'){
          $state.go('workplan.committeeParticipation')
        }
        else{
          $state.reload()
        }
      } else if (isRolAcademicManagement(ctrlModalVM.modalType)){
        if($state.current.name === 'workplan.createRole'){
          $state.go('workplan.roles')
        }
        else{
          $state.reload()
        }
    //compare for Teaching submodule
      } else if (isTeachingSubject(ctrlModalVM.modalType)){
        $state.go('workplan.teachingSubjects')
      }
      

      return $mdDialog.hide()
    }    

//comparefunctions
  //comparefunctions for investigation
    function isProduct(value){
      return value == texts.modalTypeId.product
    }
    function isProject(value){
      return value == texts.modalTypeId.project
    }
    function isCollaborationSpace(value){
      return value == texts.modalTypeId.collaborationSpace
    }
    function isProjectFormulation(value){
      return value == texts.modalTypeId.projectFormulation
    }
    function isResultsTransfer(value){
      return value == texts.modalTypeId.resultsTransfer
    }
    function isTrainingResearch(value){
      return value == texts.modalTypeId.trainingResearch
    }
  //comparefunctions for extension
    function isProjectFormulationExt(value){
      return value == texts.modalTypeId.projectFormulationExt
    }
    function isCounselingConsultancy(value){
      return value == texts.modalTypeId.counselingConsultancy
    }
    function isShortCourses(value){
      return value == texts.modalTypeId.shortCourses
    }
    function isExtensionProject(value){
      return value == texts.modalTypeId.extensionProject
    }
    function isVisibility(value){
      return value == texts.modalTypeId.visibility
    }
  //comparefunctions for consolidation CP
    function isDoctoralFormation(value){
      return value == texts.modalTypeId.doctoralFormation
    }
    function isLearningCommunitie(value){
      return value == texts.modalTypeId.learningComunity
    }
    function isTeachingDev(value){
      return value == texts.modalTypeId.teachingDev
    }
  //comparefunctions for academic management
    function isComiteeParticipation(value){
      return value == texts.modalTypeId.comiteeParticipation
    }
    function isRolAcademicManagement(value){
      return value == texts.modalTypeId.roleAcademicManagement
    }
  //comparefunctions for teaching    
    function isTeachingSubject(value){
      return value == texts.modalTypeId.teachingSubject
    }
  
    

  }
}

SuccessDialogCtrl.$inject = ['$scope', 'WorkPlanModalSrv', '$mdDialog', '$state', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/modals/successDialogCtrl.js